// @flow
import React, { Component } from 'react'
import ReactModal from 'react-modal'
import classnames from 'classnames'

type PropsT = {
  isOpen: boolean,
  onRequestClose: Function,
  contentLabel: string,
  overlayClassName: string,
  className: string,
  keepOpen?: boolean,
  onAfterOpen?: Function,
  ariaHideApp?: boolean,
  children?: any,
  shouldCloseOnOverlayClick?: boolean,
}

type ModalTitlePropsT = {
  className?: string,
  children?: any,
  onRequestClose?: Function,
}

type ModalContentPropsT = {
  className?: string,
  children?: any,
}

class Modal extends Component<PropsT> {
  appEl = null

  render() {
    const {
      keepOpen,
      onAfterOpen,
      contentLabel,
      onRequestClose,
      overlayClassName,
      className,
    } = this.props

    let {
      isOpen,
      ariaHideApp,
      children,
      shouldCloseOnOverlayClick,
    } = this.props

    if (ariaHideApp !== false) {
      ariaHideApp = true
      if (window) this.appEl = window.document.querySelector('#root')
    }

    children = React.Children.map(children, (child, index) => {
      if (child.type === ModalTitle) {
        return React.cloneElement(child, {
          onRequestClose: onRequestClose
        })
      } else {
        return child
      }
    })

    // override props if keepOpen prop is true
    shouldCloseOnOverlayClick = keepOpen ? false
      : shouldCloseOnOverlayClick === undefined ? true : shouldCloseOnOverlayClick
    isOpen = keepOpen ? true : isOpen

    return (
      <ReactModal
        isOpen={isOpen}
        ariaHideApp={ariaHideApp}
        appElement={ariaHideApp ? this.appEl : null}
        onAfterOpen={onAfterOpen ? onAfterOpen : () => {}}
        onRequestClose={onRequestClose}
        contentLabel={contentLabel}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        overlayClassName='Modal__overlay'
        className={classnames('Modal__content', className, 'Modal__content--hasClose', {
          'no-close': keepOpen
        })}
      >
        {children}
      </ReactModal>
    )
  }
}

export default Modal

export const ModalTitle = ({ className, children, onRequestClose }: ModalTitlePropsT) => (
  <section className='Modal__header__container'>
    <h3 className={classnames('Modal__header', 'Modal__header--bold', className)}>
      {children}
    </h3>
    <button
      className='Modal__close'
      aria-label='Close alert'
      type='button'
      onClick={onRequestClose}
    >
      <span className="close-icon" aria-hidden='true'>&times;</span>
    </button>
  </section>
)

export const ModalContent = ({ className, children }: ModalContentPropsT) => (
  <section className={classnames('Modal__content__container', className)}>
    {children}
  </section>
)